import Service from "../../AuthService";

const PromotionOther = {
    getPromotionOther(page) {
        return Service.get("/promotion-other?page="+page);
    },
    showPromotionOther(id) {
        return Service.get("/promotion-other/" + id);
    },
    updatePromotionOther(id, data) {
        return Service.put("/promotion-other/" + id, data);
    },
    createPromotionOther(data) {
        return Service.post("/promotion-other", data);
    },
    deletePromotionOther(id) {
        return Service.delete("/promotion-other/" + id);
    },
};

export default PromotionOther;
